/* src/app/modules/print-cards/components/cards/card-content/index-cards-3x5/generic-index-card-stack-content/generic-index-card-stack-content.component.scss */
.f12px {
  font-size: 0.75rem;
}
.f14px {
  font-size: 0.875rem;
}
.f16px {
  font-size: 1rem;
}
.f18px {
  font-size: 1.125rem;
}
.f20px {
  font-size: 1.25rem;
}
.f24px {
  font-size: 1.5rem;
}
.f32px {
  font-size: 2rem;
}
.f48px {
  font-size: 3rem;
}
.f64px {
  font-size: 4rem;
}
:host {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: stretch;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
:host .main-content {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: stretch;
  box-sizing: border-box;
  width: 18.75rem;
  padding: 1.875rem 1rem;
}
:host .main-content .brand-name-and-label-container {
  display: flex;
  flex-direction: column;
}
:host .main-content .brand-name-and-label-container .product-card-badge-outer {
  display: flex;
  padding-bottom: 0.5rem;
  min-height: 2.375rem;
}
:host .main-content .brand-name-and-label-container .product-card-badge-outer .product-card-badge-inner {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: flex-start;
  gap: 0.5rem;
}
:host .main-content .brand-name-and-label-container .product-card-badge-outer .product-card-badge {
  width: 2.375rem;
}
:host .main-content .brand-name-and-label-container .brand-name-and-label .brand-name {
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: nowrap;
  gap: 0.125rem;
}
:host .main-content .brand-name-and-label-container .brand-name-and-label .brand-name .brand-and-name {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-content: flex-start;
}
:host .main-content .brand-name-and-label-container .brand-name-and-label .brand-name .brand-and-name .product-card-brand {
  font-family: poppins, sans-serif;
  font-weight: 500;
  font-size: 0.9375rem;
  line-height: 120%;
}
:host .main-content .brand-name-and-label-container .brand-name-and-label .brand-name .brand-and-name .product-card-name {
  font-family: poppins, sans-serif;
  font-weight: 700;
  font-size: 1.875rem;
  line-height: 100%;
}
:host .main-content .brand-name-and-label-container .brand-name-and-label .print-card-label {
  align-self: flex-start;
  height: 1.375rem;
  margin: 0;
  padding: 0;
}
:host .main-content .brand-name-and-label-container .brand-name-and-label .print-card-label ::ng-deep .product-label {
  font-family: poppins, sans-serif;
  font-weight: 500;
  font-size: 1.0625rem;
  line-height: 120%;
  box-sizing: border-box;
  height: 1.375rem;
  border-radius: 0.1125rem;
  margin: 1rem 0 0 0;
  padding: 0 0.125rem;
  width: fit-content;
}
:host .main-content .type-and-price-container {
  display: flex;
  flex-direction: column;
}
:host .main-content .type-and-price-container .type-and-price {
  display: flex;
  flex-direction: row;
  gap: 0.75rem;
  align-items: center;
  justify-content: flex-end;
  height: 2.625rem;
}
:host .main-content .type-and-price-container .type-and-price .product-card-type {
  flex: 1;
  font-family: poppins, sans-serif;
  font-weight: 600;
  font-size: 0.75rem;
  font-size: 0.9375rem;
  line-height: 100%;
}
:host .main-content .type-and-price-container .type-and-price .product-card-price ::ng-deep .product-variant-price {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  font-family: poppins, sans-serif;
  font-weight: 700;
  font-size: 1.4375rem;
  line-height: 100%;
  overflow: visible;
}
:host .main-content .type-and-price-container .type-and-price .product-card-price ::ng-deep .product-variant-price .product-variant-previous-price {
  opacity: 0.5;
  font-family: poppins, sans-serif;
  font-weight: 700;
  font-size: 0.9375rem;
}
:host .color-strip {
  display: flex;
  flex-direction: column;
  justify-content: center;
  box-sizing: border-box;
  width: 11.25rem;
  padding: 0 1rem;
}
:host .color-strip .property-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  box-sizing: border-box;
  min-height: 2.71875rem;
  gap: 0.125rem;
  padding: 0.375rem 0;
  border-bottom: 1px solid #dadbde;
}
:host .color-strip .property-container .title {
  font-family: poppins, sans-serif;
  font-weight: 500;
  font-size: 0.5rem;
  line-height: 120%;
}
:host .color-strip .property-container .value {
  font-family: poppins, sans-serif;
  font-weight: 700;
  font-size: 1rem;
  line-height: 120%;
}
:host ::ng-deep .force-bold-style * {
  font-family: poppins, sans-serif;
  font-weight: 800;
}
:host ::ng-deep .force-italic-style * {
  font-family: poppins, sans-serif;
  font-style: italic;
  font-weight: 700;
}
/*# sourceMappingURL=generic-index-card-stack-content.component.css.map */
